import { render, staticRenderFns } from "./ModalImportar.vue?vue&type=template&id=4177fb42&"
import script from "./ModalImportar.vue?vue&type=script&lang=ts&"
export * from "./ModalImportar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports